import { render, staticRenderFns } from "./editArticleCategory.vue?vue&type=template&id=bfa74cfa&scoped=true&"
import script from "./editArticleCategory.vue?vue&type=script&lang=ts&"
export * from "./editArticleCategory.vue?vue&type=script&lang=ts&"
import style0 from "./editArticleCategory.vue?vue&type=style&index=0&id=bfa74cfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa74cfa",
  null
  
)

export default component.exports